import EventParticipants from './EventParticipants'

export default EventParticipants
